import { SpanStatusCode, trace } from '@opentelemetry/api'

import { APP_NAME } from '../../config/costants'
import { defaultExceptionType, type ExceptionsAPI } from './types'

/**
 * The function `initializeExceptionsAPI` initializes an ExceptionsAPI object with a `traceError`
 * method that records and traces errors.
 * @returns The function `initializeExceptionsAPI` is returning an object with a single property
 * `traceError`.
 */
export function initializeExceptionsAPI(): ExceptionsAPI {
  /**
   * The function `traceError` is a TypeScript function that traces and records an error with additional
   * metadata using a tracing API.
   * @param error - The `error` parameter is the error object that you want to trace. It can be any
   * JavaScript error object, such as `Error`, `TypeError`, or a custom error object.
   * @param  - - `error`: The error object that needs to be traced.
   */
  const traceError: ExceptionsAPI['traceError'] = (error, { metas } = {}) => {
    const tracer = trace.getTracer(APP_NAME)

    // Create a span. A span must be closed.
    tracer.startActiveSpan(defaultExceptionType, (span) => {
      span.recordException(error)
      span.setAttributes(metas ?? {})
      span.setStatus({ code: SpanStatusCode.ERROR })
      span.end()
    })
  }

  return {
    traceError,
  }
}
